import * as React from 'react';

const Underline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.66669 4.16669V9.16669C6.66669 10.0507 7.01788 10.8986 7.643 11.5237C8.26812 12.1488 9.11597 12.5 10 12.5C10.8841 12.5 11.7319 12.1488 12.357 11.5237C12.9822 10.8986 13.3334 10.0507 13.3334 9.16669V4.16669M4.16669 15.8334H15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default Underline;
